import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=a96d2d3e&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"
import style0 from "./SignUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports